import { useEffect, useMemo } from 'react';

export default function useRegisterTooltipTarget(sequence, id, ref, overrides) {
  const registerTooltipTarget = sequence?.registerTooltipTarget;
  const unregisterTooltipTarget = sequence?.unregisterTooltipTarget;

  const title = overrides?.title;
  const description = overrides?.description;
  const placement = overrides?.placement;
  const align = overrides?.align;

  const stableOverrides = useMemo(
    () => ({
      ...(title !== undefined ? { title } : {}),
      ...(description !== undefined ? { description } : {}),
      ...(placement !== undefined ? { placement } : {}),
      ...(align !== undefined ? { align } : {}),
    }),
    [title, description, placement, align],
  );

  useEffect(() => {
    if (!registerTooltipTarget || !unregisterTooltipTarget || !id || !ref) {
      return;
    }

    registerTooltipTarget(id, ref, stableOverrides);

    return () => {
      unregisterTooltipTarget(id);
    };
  }, [
    id,
    ref,
    registerTooltipTarget,
    unregisterTooltipTarget,
    stableOverrides,
  ]);
}
